import { Paddle } from '@paddle/paddle-js';
import { Button, Col } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from '../../store/store';
import {
    getOrganizationEmail,
    getOrganizationId,
} from '../../store/selector/organization.selector';
import { useNavigate } from 'react-router-dom';

interface IProps {
    show: boolean;
    onHide: () => void;
    paddle: Paddle;
}
const Paywall = ({ paddle, ...props }: IProps) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const organizationId = useAppSelector(getOrganizationId);
    const organizationEmail = useAppSelector(getOrganizationEmail);

    const openPaddleProCheckout = (event: any) => {
        event.preventDefault();
        if (organizationId && organizationEmail) {
            paddle.Checkout.open({
                customer: {
                    email: organizationEmail,
                },
                settings: {
                    displayMode: 'overlay',
                    theme: 'light',
                    locale: 'en',
                },
                customData: {
                    crm_id: organizationId,
                    utm_source: 'google',
                },
                items: [
                    {
                        priceId: 'pri_01hjqnr9bwep13gkj0h2w89612',
                        quantity: 1,
                    },
                ],
            });

            props.onHide;
        }
    };

    const openPaddleBetaCheckout = (event: any) => {
        event.preventDefault();
        if (organizationId && organizationEmail) {
            paddle.Checkout.open({
                customer: {
                    email: organizationEmail,
                },
                settings: {
                    displayMode: 'overlay',
                    theme: 'light',
                    locale: 'en',
                },
                customData: {
                    crm_id: organizationId,
                    utm_source: 'google',
                },
                items: [
                    {
                        priceId: 'pri_01hrwge2qrh7sg19mhn18whecv',
                        quantity: 1,
                    },
                ],
            });
            props.onHide;
        }
    };

    return (
        <div className="tw-w-full">
            <div className="tw-w-full tw-flex tw-justify-center">
                <div className="tw-w-full tw-flex tw-flex-col lg:tw-flex-row tw-gap-x-4 tw-gap-y-4 tw-px-10 tw-pt-10 tw-max-w-8xl lg:tw-justify-center">
                    <Col className="paywall_col">
                        <div className="p-3">
                            <p className="fw-bold fs-5 m-0 text-primary">Starter </p>
                            {/* Plan price */}
                            <div className="price">
                                <div className="price-offer mt-3">
                                    <div className="d-flex flex-row mb-2">
                                        <p className="fw-bold fs-3 m-0 p-0">$40</p>
                                        <span className="text-light m-0 p-0 fs-6"> / month </span>
                                    </div>
                                </div>

                                <div className="price-content">
                                    <ul>
                                        <li>
                                            <i className="ph ph-check me-1"></i>1 brand, 5 campaigns
                                        </li>
                                        <li>
                                            <i className="ph ph-check me-1"></i>AI design, image,
                                            and text
                                        </li>
                                        <li>
                                            <i className="ph ph-check me-1"></i>AI product
                                            photography
                                        </li>
                                        <li>
                                            <i className="ph ph-check me-1"></i>Your Templates
                                        </li>
                                        <li>
                                            <i className="ph ph-check me-1"></i>Our Template Library
                                        </li>
                                        <li className="tw-flex tw-items-start">
                                            <i className="ph ph-check me-1"></i>Bulk upload to Cloud
                                            Campaign, SocialPilot, and Hootsuite
                                        </li>
                                        <li>
                                            <i className="ph ph-check me-1"></i>Optional: Add
                                            Pixii's Scheduler for $20 per brand
                                        </li>
                                    </ul>
                                </div>
                                <div className="pt-3  mt-3 mb-3 pb-0 d-flex flex-column justify-content-end">
                                    <Button
                                        variant="primary"
                                        className="mb-3"
                                        onClick={(e) => openPaddleBetaCheckout(e)}
                                    >
                                        {' '}
                                        Start Now
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col className="paywall_col">
                        <div className="p-3">
                            <p className="fw-bold fs-5 m-0 text-primary">Pro </p>
                            {/* Plan price */}
                            <div className="price">
                                <div className="price-offer mt-3">
                                    <div className="d-flex flex-row mb-2">
                                        <p className="fw-bold fs-3 m-0 p-0">$325</p>
                                        <span className="text-light m-0 p-0 fs-6"> / month </span>
                                    </div>
                                </div>
                                <div className="price-content">
                                    <ul>
                                        <li>
                                            <i className="ph ph-check me-1"></i> 15 brands, 150
                                            campaigns
                                        </li>
                                        <li>
                                            <i className="ph ph-check me-1"></i> AI design, image,
                                            and text
                                        </li>
                                        <li>
                                            <i className="ph ph-check me-1"></i> AI product
                                            photography
                                        </li>
                                        <li>
                                            <i className="ph ph-check me-1"></i> Your Templates
                                        </li>
                                        <li>
                                            <i className="ph ph-check me-1"></i> Our Template
                                            Library
                                        </li>

                                        <li>
                                            <i className="ph ph-check me-1"></i> Bulk upload to
                                            Cloud Campaign, SocialPilot, and Hootsuite
                                        </li>
                                        <li>
                                            <i className="ph ph-check me-1"></i> Optional: Add
                                            Pixii's Scheduler for $20 per brand
                                        </li>
                                    </ul>
                                </div>
                                <div className="pt-3  mt-3 mb-3 pb-0 d-flex flex-column justify-content-end">
                                    <Button
                                        variant="primary"
                                        className="mb-3"
                                        onClick={(e) => openPaddleProCheckout(e)}
                                    >
                                        {' '}
                                        Start Now
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col className="paywall_col">
                        <div className="p-3">
                            <p className="fw-bold fs-5 m-0 text-primary">Enterprise Discount</p>
                            <div className="price">
                                <div className="price-offer mt-3">
                                    <div className="d-flex flex-row mb-2">
                                        <p className="fw-bold fs-3 m-0 p-0">Contact Us</p>
                                    </div>
                                </div>

                                <div className="price-content">
                                    <ul>
                                        <li>
                                            <i className="ph ph-check me-1"></i> Unlimited brands,
                                            unlimited campaigns
                                        </li>
                                        <li>
                                            <i className="ph ph-check me-1"></i> AI design, image,
                                            and text
                                        </li>
                                        <li>
                                            <i className="ph ph-check me-1"></i> AI product
                                            photography
                                        </li>
                                        <li>
                                            <i className="ph ph-check me-1"></i> Your Templates
                                        </li>
                                        <li>
                                            <i className="ph ph-check me-1"></i> Our Template
                                            Library
                                        </li>

                                        <li>
                                            <i className="ph ph-check me-1"></i> Bulk upload to
                                            Cloud Campaign, SocialPilot, and Hootsuite
                                        </li>
                                        <li>
                                            <i className="ph ph-check me-1"></i> Optional: Add
                                            Pixii's Scheduler for $20 per brand
                                        </li>
                                    </ul>
                                </div>
                                <div className="pt-3 mt-3 pb-0 d-flex flex-column justify-content-end">
                                    <Button
                                        variant="primary"
                                        className="mb-3"
                                        onClick={() => {
                                            window.location.href =
                                                'https://calendly.com/pixiiai/demo?month=2024-01';
                                        }}
                                    >
                                        {' '}
                                        Book a Demo
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Col>
                </div>
            </div>
            <div className="tw-w-full tw-flex tw-justify-center">
                <div className="tw-w-full tw-max-w-8xl tw-flex tw-justify-between tw-items-center tw-px-10 border-0 pt-0">
                    <p
                        className="fst-italic   text-start text-light"
                        style={{ fontSize: '0.85rem' }}
                    >
                        *Subject to fair use.
                    </p>
                    <a
                        href="mailto:consult@pixii.ai"
                        className="text-light tw-block"
                        style={{ fontSize: '0.85rem', cursor: 'pointer' }}
                    >
                        Help
                    </a>
                </div>
            </div>
        </div>
    );
};
export default Paywall;
